import { useUserPermission } from "@helpers/userPermissionHelper";
import { AssessmentResult, ExistingExamineeDetails } from "@store/generalTypes";
import { DownloadFollowupButtons } from "./DownloadFollowupButtons";
import { ExamineeBanner } from "./examineeBanner";
import { AssessmentMoreDetails } from "./moreDetails";
import { NotesBanner } from "./notesBanner";

export const AssessmentDetailsHeader = ({ ...props }: AssessmentDetailsHeaderProps): JSX.Element => {
    const { isClinician, isClinicalAdmin } = useUserPermission({ useCurrentLocation: true });
    return (
        <>
            <ExamineeBanner
                assessment={props.assessment}
                examinee={props.examinee}
                showDetails={isClinician || isClinicalAdmin}
            />
            {(isClinician || isClinicalAdmin) && (
                <AssessmentMoreDetails {...props.examinee} assessmentDate={props.assessment.launchedDate} />
            )}
            <div className="columns mt-3" data-html2canvas-ignore="true">
                <div className="column">
                    <NotesBanner {...props.assessment} />
                </div>
                <div className="column is-one-fifth">
                    <DownloadFollowupButtons
                        handlePrint={props.handlePrint}
                        status={props.assessment.status}
                        handleChangeStatus={props.handleChangeStatus}
                    />
                </div>
            </div>
        </>
    );
};

interface AssessmentDetailsHeaderProps {
    assessment: AssessmentResult;
    examinee: ExistingExamineeDetails;
    handlePrint: () => void;
    handleChangeStatus: (note: string) => Promise<void>;
}
